import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #CHECKBOX-FIELD
\*------------------------------------ */
/**
 * 1) Check box item
 */
.cat-checkbox-field {
  display: contents;
}

/**
 * Align checkbox with checkbox label
 */
.cat-c-checkbox-field {
  margin: var(--cat-checkbox-field-margin-top, var(--cat-space-x-small)) 0 0 0;
  padding: 0;
  position: relative;
  background-color: var(--cat-dropdown-checkbox-background);
  /**
   * Remove top margin from first .cat-c-checkbox-field
   */
}
:host(:first-child) .cat-c-checkbox-field {
  margin-block-start: 0;
}
.cat-c-checkbox-field.cat-is-checked:not(.cat-is-disabled) {
  background-color: var(--cat-dropdown-checkbox-checked-background, var(--cat-theme-color-background-default));
}
.cat-c-checkbox-field.cat-c-checkbox-field-is-readonly, .cat-c-checkbox-field.cat-c-checkbox-field-is-loading {
  pointer-events: none;
}
.cat-c-checkbox-field.cat-is-disabled {
  pointer-events: auto;
  cursor: not-allowed;
}

.cat-c-checkbox-field__container {
  display: flex;
  position: relative;
}

/**
* Remove top margin from checkbox fields if there is a hover
*/
.cat-has-hover {
  margin: calc(var(--size-base-unit) * 0.125) calc(var(--size-base-unit) * 0.25) 0;
}

/**
 * To highlight the searched text in list
 */
.cat-c-checkbox-field__highlighted {
  background-color: var(--cat-color-brand-cat-yellow);
}

/**
 * Inline checkbox wrapping label
 */
.cat-c-checkbox-field__label {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: flex;
  color: var(--cat-checkbox-field-color, var(--cat-theme-color-content-xstrong));
  inset-block-start: calc(var(--size-base-unit) * 0.25);
  padding-inline-start: var(--cat-space-3x-small);
  flex: 1;
  word-break: break-word;
  cursor: pointer;
  padding-block: var(--cat-space-3x-small);
  /**
   * Disable label text
   */
  /**
  * Add hover styles to the checkbox label
  */
  /**
   * Visually hide the label
   */
}
.cat-c-checkbox-field.cat-is-disabled .cat-c-checkbox-field__label {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}
.cat-has-hover .cat-c-checkbox-field__label {
  margin-inline-start: calc(-1 * var(--cat-space-3x-large));
  padding: var(--cat-dropdown-checkbox-padding, var(--cat-space-2x-small) var(--cat-space-x-small) var(--cat-space-2x-small) var(--cat-space-3x-large));
  padding-inline-start: var(--cat-dropdown-checkbox-padding-left, var(--cat-space-4x-large));
  border-radius: calc(var(--size-base-unit) * 0.25);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-has-hover .cat-c-checkbox-field__label:hover, .cat-has-hover .cat-c-checkbox-field__label:focus {
  background-color: var(--cat-theme-color-background-subtle);
}
.cat-has-hover .cat-c-checkbox-field__label:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-checkbox-field--hidden-label .cat-c-checkbox-field__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.cat-is-inline .cat-c-checkbox-field__label {
  flex: none;
}

/**
 * Checkbox item input
 */
.cat-c-checkbox__input {
  /**
  * Add a margin to the checkbox input if has a hover
  */
}
.cat-c-checkbox__input[aria-disabled=true] {
  pointer-events: none;
}
.cat-has-hover .cat-c-checkbox__input {
  inset-block-start: var(--cat-dropdown-checkbox-input-padding, var(--cat-space-3x-small));
  margin-inline-start: var(--cat-space-x-small);
  margin-block-start: var(--cat-dropdown-checkbox-input-padding, calc(var(--size-base-unit) * 0.25));
}

.cat-c-checkbox__custom_wrapper {
  /**
  * Add a margin to the checkbox input if has a hover
  */
}
.cat-c-checkbox__custom_wrapper[aria-disabled=true] {
  pointer-events: none;
}
.cat-has-hover .cat-c-checkbox__custom_wrapper {
  margin-block-start: var(--cat-dropdown-checkbox-input-padding, calc(var(--size-base-unit) * 0.25));
  margin-inline-start: var(--cat-space-x-small);
}

/**
 * Custom check positioned absolutely over the input
 */
.cat-c-checkbox__custom-check {
  /**
  * Move the checkbox custom check if has a hover
  */
}
.cat-has-hover .cat-c-checkbox__custom-check {
  margin-inline-start: var(--cat-space-x-small);
  margin-block-start: var(--cat-dropdown-checkbox-input-padding, calc(var(--size-base-unit) * 0.25));
}

/**
  * Show focus ring around the checkbox and label input on keyboard focus
*/
.cat-c-checkbox-field.cat-has-hover .cat-c-checkbox__input:focus-visible ~ label,
.cat-c-checkbox-field.cat-has-hover .cat-c-checkbox-focused ~ label {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-checkbox-field.cat-has-hover .cat-c-checkbox__input:focus-visible + .cat-c-checkbox__custom-check,
.cat-c-checkbox-field.cat-has-hover .cat-c-checkbox-focused + .cat-c-checkbox__custom-check {
  outline: none;
}

/**
* Add disabled styles to the checkbox item
*/
.cat-is-disabled {
  cursor: not-allowed;
}
.cat-is-disabled:hover, .cat-is-disabled:focus {
  background-color: transparent;
}
.cat-is-disabled .cat-c-checkbox-field__label {
  pointer-events: none;
}

/**
   * Checkbox control input
   * 1) Make control dimensions same as outer container
   * 2) Hide native form controls
   */
.cat-c-checkbox__input {
  display: block;
  margin: 0;
  z-index: 4;
  flex-shrink: 0;
  width: calc(var(--size-base-unit) * 4); /* 1 */
  height: calc(var(--size-base-unit) * 4); /* 1 */
  cursor: pointer;
  opacity: 0; /* 2 */
  /**
     * Disabled checkbox input
     */
  /**
     * Focus visible for checkbox input
     */
}
.cat-c-checkbox__input[aria-disabled=true] {
  cursor: not-allowed;
}
.cat-c-checkbox__input:focus-visible, .cat-c-checkbox__input.cat-c-checkbox-focused {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
   * Custom checkbox
   * 1) Make control dimensions same as outer container
   */
.cat-c-checkbox__custom-check {
  position: absolute;
  inset-block: 0; /* 1 */
  inset-inline: 0; /* 1 */ /* 1 */ /* 1 */
  width: calc(var(--size-base-unit) * 2.25);
  height: calc(var(--size-base-unit) * 2.25);
  border-radius: calc(var(--size-base-unit) * 0.25);
  flex-shrink: 0;
  z-index: 1;
  /**
     * Custom checkbox background
     * 1) Make control dimensions same as outer container
     * 2) Stack background behind checkbox foreground
     */
  /**
     * Custom checkbox checkmark
     * 1) Position checkmark in center of box
     * 2) Hide checkmark based by default
     */
}
.cat-c-checkbox__custom-check:before {
  content: "";
  position: absolute;
  inset-block: 0; /* 1 */
  inset-inline: 0; /* 1 */ /* 1 */ /* 1 */
  z-index: 1; /* 2 */
  display: block;
  border: var(--cat-border-width-sm) solid var(--cat-theme-color-form-border);
  background-color: var(--cat-theme-color-background-default);
  border-radius: calc(var(--size-base-unit) * 0.25);
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
     * Custom checkbox background inside of disabled control
     */
  /**
     * Custom checkbox background inside of checked control
     */
  /**
     * Custom checkbox background inside of checked and hovered control
     */
  /**
     * Custom checkbox background inside of checked control
     */
}
.cat-c-checkbox__input[aria-disabled=true] ~ .cat-c-checkbox__custom-check:before {
  border-color: var(--cat-theme-color-border-disabled);
  background-color: var(--cat-theme-color-background-disabled);
  cursor: not-allowed;
}
.cat-c-checkbox__input:checked ~ .cat-c-checkbox__custom-check:before {
  background-color: var(--cat-theme-color-background-brand);
  border-color: var(--cat-theme-color-border-strong);
}
.cat-c-checkbox__input:checked:hover ~ .cat-c-checkbox__custom-check:before {
  border-color: var(--cat-theme-color-border-strong);
}
.cat-c-checkbox__input:checked[aria-disabled=true] ~ .cat-c-checkbox__custom-check:before {
  background-color: var(--cat-theme-color-background-disabled);
  border-color: var(--cat-theme-color-border-disabled);
}
:is(.cat-c-checkbox-field-is-readonly, .cat-c-checkbox-field-is-loading) .cat-c-checkbox__custom-check:before {
  border-color: var(--cat-theme-color-border-disabled);
}
.cat-c-checkbox__custom-check:after {
  content: "";
  position: absolute;
  inset-block-start: 50%; /* 1 */
  inset-inline-start: 50%; /* 1 */
  z-index: 2;
  display: block;
  width: 12px;
  height: 12px;
  transform: translate(var(--rtlTranslateX, -50%), -50%);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.2046 1.50267C10.0385 1.52328 9.88377 1.60005 9.77259 1.71697C9.75609 1.73433 8.46195 3.2985 6.89672 5.1929C5.33149 7.08731 4.04781 8.64051 4.04409 8.64447C4.03767 8.65129 3.99258 8.59409 3.14996 7.51034C2.36322 6.49844 2.2571 6.36357 2.21415 6.32101C2.10819 6.216 1.98498 6.1522 1.83477 6.12456C1.78668 6.11571 1.68911 6.11292 1.63504 6.11884C1.28388 6.15732 1.01392 6.44811 1.00081 6.802C0.997889 6.88072 1.00327 6.93304 1.0217 7.00509C1.0424 7.08602 1.07064 7.15056 1.11447 7.21711C1.1408 7.25709 2.96144 9.59976 3.0032 9.64739C3.18482 9.85457 3.42944 10.0043 3.69789 10.0726C3.80621 10.1002 3.8868 10.1112 4.00392 10.1142C4.33488 10.1227 4.64958 10.014 4.91157 9.80057C5.01752 9.71426 4.89343 9.86282 7.96692 6.14299C9.56 4.21491 10.8687 2.62753 10.8826 2.60658C10.9668 2.47919 11.0052 2.34057 10.9995 2.18547C10.9906 1.94592 10.8659 1.73223 10.6604 1.60438C10.5889 1.55992 10.4934 1.52356 10.4087 1.5086C10.3638 1.50068 10.2478 1.4973 10.2046 1.50267Z' fill='black'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  opacity: 0; /* 2 */
  /**
     * Actual checkbox of the checked input
     * 1) Hide checkmark based on if input is checked
     */
}
.cat-c-checkbox__input:checked ~ .cat-c-checkbox__custom-check:after {
  opacity: 1; /* 1 */
}
.cat-c-checkbox__input:checked[aria-disabled=true] ~ .cat-c-checkbox__custom-check:after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.2046 1.50265C10.0385 1.52326 9.88377 1.60004 9.77259 1.71696C9.75609 1.73431 8.46195 3.29848 6.89672 5.19289C5.33149 7.08729 4.04781 8.6405 4.04409 8.64445C4.03767 8.65128 3.99258 8.59408 3.14996 7.51032C2.36322 6.49843 2.2571 6.36356 2.21415 6.321C2.10819 6.21599 1.98498 6.15218 1.83477 6.12455C1.78668 6.11569 1.68911 6.1129 1.63504 6.11883C1.28388 6.15731 1.01392 6.4481 1.00081 6.80199C0.997889 6.8807 1.00327 6.93302 1.0217 7.00507C1.0424 7.086 1.07064 7.15055 1.11447 7.2171C1.1408 7.25708 2.96144 9.59974 3.0032 9.64738C3.18482 9.85455 3.42944 10.0043 3.69789 10.0726C3.80621 10.1002 3.8868 10.1111 4.00392 10.1142C4.33488 10.1227 4.64958 10.014 4.91157 9.80056C5.01752 9.71425 4.89343 9.8628 7.96692 6.14298C9.56 4.21489 10.8687 2.62752 10.8826 2.60657C10.9668 2.47917 11.0052 2.34055 10.9995 2.18546C10.9906 1.9459 10.8659 1.73222 10.6604 1.60437C10.5889 1.5599 10.4934 1.52354 10.4087 1.50859C10.3638 1.50066 10.2478 1.49729 10.2046 1.50265Z' fill='%23AAAAAA'/%3E%3C/svg%3E");
}

/**
   * Apply "indeterminate" style to checkbox. "Indeterminate" states are for
   * checkboxes masked states of the checkbox. More here - https://css-tricks.com/indeterminate-checkboxes/
   */
.cat-is-indeterminate .cat-c-checkbox__input {
  /**
     * Apply disabled "indeterminate" styles to checkbox
     */
  /**
     * Apply "indeterminate" styles to checkbox
     */
}
.cat-is-indeterminate .cat-c-checkbox__input[aria-disabled=true] ~ .cat-c-checkbox__custom-check:before {
  background-color: var(--cat-theme-color-background-disabled);
  border-color: var(--cat-theme-color-border-disabled);
}
.cat-is-indeterminate .cat-c-checkbox__input ~ .cat-c-checkbox__custom-check {
  /**
     * "Indeterminate" state SVG style (just a - instead of a ✓)
     */
}
.cat-is-indeterminate .cat-c-checkbox__input ~ .cat-c-checkbox__custom-check:before {
  background-color: var(--cat-theme-color-background-brand);
  border-color: var(--cat-theme-color-border-strong);
}
.cat-is-indeterminate .cat-c-checkbox__input ~ .cat-c-checkbox__custom-check:after {
  opacity: 1;
  width: 12px;
  height: 12px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 16 16' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.66656 8.28319C2.66656 7.75852 3.02759 7.33319 3.47293 7.33319L12.5269 7.33319C12.9722 7.33319 13.3332 7.75852 13.3332 8.28319C13.3332 8.80786 12.9722 9.23319 12.5269 9.23319L3.47293 9.23319C3.02759 9.23319 2.66656 8.80786 2.66656 8.28319Z' fill='black'/%3E%3C/svg%3E");
}
.cat-is-indeterminate .cat-c-checkbox__input[aria-disabled=true] ~ .cat-c-checkbox__custom-check:after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.99988 6.2124C1.99988 5.8189 2.27064 5.4999 2.60465 5.4999L9.3951 5.4999C9.72911 5.4999 9.99988 5.8189 9.99988 6.2124C9.99988 6.60591 9.72911 6.9249 9.3951 6.9249L2.60465 6.9249C2.27064 6.9249 1.99988 6.60591 1.99988 6.2124Z' fill='%23AAAAAA'/%3E%3C/svg%3E");
}

.cat-c-checkbox__input {
  padding: var(--cat-space-3x-small);
}

.cat-c-checkbox__custom-check {
  inset-inline-start: calc(var(--size-base-unit) * 0.875);
  inset-block-start: calc(var(--size-base-unit) * 0.875);
}

/**
* If status is error
*/
.cat-c-checkbox-field-is-error:not(.cat-is-disabled, .cat-c-checkbox-field-is-readonly) .cat-c-checkbox__input ~ .cat-c-checkbox__custom-check:before,
.cat-c-checkbox-field-is-error:not(.cat-is-disabled, .cat-c-checkbox-field-is-readonly) .cat-c-checkbox__input:checked ~ .cat-c-checkbox__custom-check:before {
  border: 2px solid var(--cat-theme-color-border-utility-error);
}

/**
 * if readonly is true
 */
.cat-c-checkbox-field-is-readonly .cat-c-checkbox__input:checked ~ .cat-c-checkbox__custom-check:before, .cat-c-checkbox-field-is-readonly.cat-is-indeterminate .cat-c-checkbox__input ~ .cat-c-checkbox__custom-check:before {
  background-color: var(--cat-theme-color-background-default);
  border: var(--cat-border-width-sm) solid var(--cat-theme-color-border-disabled);
}

.cat-c-checkbox--label {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  color: var(--cat-theme-color-content-default);
  text-overflow: ellipsis;
  font-size: var(--cat-font-size-14);
  line-height: var(--cat-line-height-20);
}
.cat-is-disabled .cat-c-checkbox--label {
  color: var(--cat-theme-color-content-disabled);
}

/**
 * checkbox required
 * 1) If the checkbox is require, then the required label will display
 */
.cat-c-checkbox__notation {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  margin-inline: var(--cat-space-3x-small);
  color: var(--cat-theme-color-content-subtle);
  margin-block: var(--cat-space-3x-small);
}
.cat-is-disabled .cat-c-checkbox__notation {
  color: var(--cat-theme-color-content-disabled);
}

/**
 * CheckBox in loading state
 */
.cat-c-checkbox-loading {
  margin-block-start: var(--cat-space-x-small);
  margin-inline-start: var(--cat-space-3x-small);
}

.cat-c-checkbox-field__fieldnote-loader {
  margin-inline-start: calc(var(--size-base-unit) * 4.5);
}

.cat-c-checkbox__custom_wrapper {
  position: absolute;
  width: calc(var(--size-base-unit) * 4);
  height: calc(var(--size-base-unit) * 4);
  padding: var(--cat-space-3x-small);
  /**
  * Custom checkbox background inside of hovered control
  */
  /**
  * Custom checkbox background in active/pressed state
  */
}
.cat-c-checkbox__input:hover + .cat-c-checkbox__custom_wrapper {
  border-color: var(--cat-theme-color-form-border);
  background-color: var(--cat-theme-color-background-default-hover);
  border-radius: calc(var(--size-base-unit) * 0.25);
}
.cat-c-checkbox__input:hover + .cat-c-checkbox__custom_wrapper .cat-has-hover {
  background-color: transparent;
}
.cat-c-checkbox__input:active:not([aria-disabled=true]) + .cat-c-checkbox__custom_wrapper {
  border: none;
  background-color: var(--cat-theme-color-button-background-active);
  border-radius: calc(var(--size-base-unit) * 0.25);
}
.cat-c-checkbox__input:active:not([aria-disabled=true]) + .cat-c-checkbox__custom_wrapper.cat-c-checkbox-field-is-readonly {
  background-color: none;
}

/**
  * Custom checkbox focus state when hasHover is false
  */
.cat-c-checkbox-field:not(.cat-has-hover) .cat-c-checkbox__input:focus-visible + .cat-c-checkbox__custom_wrapper,
.cat-c-checkbox-field:not(.cat-has-hover) .cat-c-checkbox-focused + .cat-c-checkbox__custom_wrapper {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  border-radius: calc(var(--size-base-unit) * 0.25);
}

/* Flex container for both Icon and Fieldnote */
.cat-c-checkbox-field__fieldnote-container {
  display: flex;
  gap: var(--cat-space-small);
  margin-inline-start: var(--cat-space-x-small);
}
.cat-has-hover .cat-c-checkbox-field__fieldnote-container {
  gap: var(--cat-space-medium);
  margin-inline-start: var(--cat-space-medium);
}

.cat-c-checkbox--fieldnote {
  --cat-field-note-margin-block-start: 0;
  display: inline-flex;
  align-items: center;
}
.cat-c-checkbox--fieldnote:has(slot[name=field-note]) {
  margin-inline-start: calc(var(--size-base-unit) * 3.8);
}

.cat-c-checkbox-field:not(.cat-c-checkbox-field--has-error) :is([part=error-icon], .cat-c-checkbox-errornote-slot), .cat-c-checkbox-field:not(.cat-c-checkbox-field--has-warning) :is([part=warning-icon], .cat-c-checkbox-warningnote-slot), .cat-c-checkbox-field:not(.cat-c-checkbox-field--has-field-note) .cat-c-checkbox-fieldnote-slot {
  display: none;
}
`;
       